import { Injectable } from '@angular/core';

import { countries } from 'country-data';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  getAllCountries(addRestOfWorld = true) {
    if (!addRestOfWorld) {
      return countries.all;
    }

    return countries.all.concat({
      alpha2: 'ZZ',
      alpha3: 'ZZZ',
      countryCallingCodes: [],
      name: 'Rest of The World',
      status: 'assigned',
    } as any);
  }

  countryDialCodes(addRestOfWorld = false) {
    return this.getAllCountries(addRestOfWorld)
      .filter((country) => country.status === 'assigned')
      .filter((country) => country.countryCallingCodes.length >= 1)
      .map((country) => ({
        name: country.name,
        dialCode: country.countryCallingCodes[0],
        code: country.alpha2,
      }));
  }

  countrySelectItems(addRestOfWorld = false, valueIsCode = false) {
    return this.getAllCountries(addRestOfWorld)
      .filter((country) => country.status === 'assigned')
      .map((country) => ({
        value: valueIsCode
          ? country.alpha2
          : country.name,
        name: country.name,
        code: country.alpha2,
      }));
  }

  getCountryName(countryCode) {
    const country = this.getAllCountries().find((element) => {
      return element.alpha2 === countryCode;
    });

    return country.name;
  }

  isAllCountries(listOfCountries: string[]) {
    return listOfCountries?.length === 249;
  }
}
